// extracted by mini-css-extract-plugin
export var closeButton = "_gr-2";
export var closeButtonIcon = "_gr-3";
export var lightboxContent = "_gr-1";
export var lightboxOverlay = "_gr-0";